// src/index.ts
import {
  AllSelection,
  TextSelection,
  NodeSelection
} from "prosemirror-state";
import { canSplit } from "prosemirror-transform";
var splitSplittableBlock = splitBlockAs(
  (node, atEnd, $from) => {
    if (!atEnd)
      return null;
    const defaultType = $from.depth == 0 ? null : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
    if (!defaultType)
      return null;
    const attrs = inheritSplittableAttrs(node, defaultType);
    return attrs ? { type: defaultType, attrs } : null;
  }
);
function splitBlockAs(splitNode) {
  return (state, dispatch) => {
    let { $from, $to } = state.selection;
    if (state.selection instanceof NodeSelection && state.selection.node.isBlock) {
      if (!$from.parentOffset || !canSplit(state.doc, $from.pos))
        return false;
      if (dispatch)
        dispatch(state.tr.split($from.pos).scrollIntoView());
      return true;
    }
    if (!$from.parent.isBlock)
      return false;
    if (dispatch) {
      let atEnd = $to.parentOffset == $to.parent.content.size;
      let tr = state.tr;
      if (state.selection instanceof TextSelection || state.selection instanceof AllSelection)
        tr.deleteSelection();
      let deflt = $from.depth == 0 ? null : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
      let splitType = splitNode && splitNode($to.parent, atEnd, $from);
      let types = splitType ? [splitType] : atEnd && deflt ? [{ type: deflt }] : void 0;
      let can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
      if (!types && !can && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : void 0)) {
        if (deflt)
          types = [{ type: deflt }];
        can = true;
      }
      if (can) {
        tr.split(tr.mapping.map($from.pos), 1, types);
        if (!atEnd && !$from.parentOffset && $from.parent.type != deflt) {
          let first = tr.mapping.map($from.before()), $first = tr.doc.resolve(first);
          if (deflt && $from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt))
            tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
        }
      }
      dispatch(tr.scrollIntoView());
    }
    return true;
  };
}
function inheritSplittableAttrs(prev, type) {
  const prevAttrs = findSplittableAttrs(prev.type, true);
  const nextAttrs = findSplittableAttrs(type, true);
  const attrs = prevAttrs.filter((attr) => nextAttrs.includes(attr));
  if (attrs.length === 0) {
    return null;
  }
  return Object.fromEntries(attrs.map((attr) => [attr, prev.attrs[attr]]));
}
function findSplittableAttrs(type, splittable) {
  var _a;
  const attrs = [];
  for (const [attr, spec] of Object.entries((_a = type.spec.attrs) != null ? _a : {})) {
    if (spec.splittable === splittable) {
      attrs.push(attr);
    }
  }
  return attrs;
}
function defaultBlockAt(match) {
  for (let i = 0; i < match.edgeCount; i++) {
    const { type } = match.edge(i);
    if (type.isTextblock && !type.hasRequiredAttrs())
      return type;
  }
  return null;
}
export {
  splitBlockAs,
  splitSplittableBlock
};
